import { DSD_EDITOR_MODE, type DsdEditorMode } from "@/types/dsd";

const DSD_EDITOR_APP_TITLE = "DSD 리뷰";

const DSD_EDITOR_MODE_ITEMS = [
  { value: DSD_EDITOR_MODE.upload, label: "새 DSD 업로드" },
  { value: DSD_EDITOR_MODE.existingReport, label: "기존 DSD 선택" },
] as const satisfies ReadonlyArray<{
  value: DsdEditorMode;
  label: string;
}>;

const DSD_EDITOR_SOURCE_COPY = {
  upload: {
    file: {
      label: "DSD 파일",
      description: ".dsd 형식",
    },
    errorMessage: "DSD 파일 업로드 중 오류가 발생했습니다.",
  },
  existingReport: {
    picker: {
      title: "DSD 선택",
      description: "기존 DSD를 선택하여 리뷰합니다",
      emptyMessage: "업로드된 DSD가 없습니다.",
      errorMessage: "업로드한 DSD 파일 목록을 불러오는 중 오류가 발생했습니다.",
      missingFilename: "(파일명 없음)",
    },
    meta: {
      uploadedAtPrefix: "업로드",
    },
  },
} as const;

export const DSD_EDITOR_COPY = {
  appTitle: DSD_EDITOR_APP_TITLE,
  page: {
    description:
      "DSD 보고서를 업로드하여 본문과 주석 사이 연동되는 값과 오탈자를 검토하세요.",
  },
  modeItems: DSD_EDITOR_MODE_ITEMS,
  reviewAction: {
    startLabel: "리뷰 시작",
    pendingLabel: "리뷰 준비 중...",
  },
  sources: DSD_EDITOR_SOURCE_COPY,
  pagination: {
    previous: "이전",
    next: "다음",
    pageLabel: (page: number) => `${page}페이지`,
  },
  view: {
    fallbackTitle: DSD_EDITOR_APP_TITLE,
    missingDocumentMessage: "확인할 DSD 문서를 찾을 수 없습니다.",
    backToUpload: "업로드 페이지로 이동",
    backAriaLabel: "뒤로 가기",
  },
} as const;
